module.exports = __webpack_public_path__ + "static/media/renBTC-logo.b262d4ce.png";